// Shared types for user management
import { SellerStatus } from "@b2b/services";

export interface PendingUser {
  id: string;
  auth0Id: string;
  email: string;
  profileImage?: string | null;
  firstName: string | null;
  lastName: string | null;
  phone: string | null;
  role: string;
  isActive: boolean;
  sellerStatus?: SellerStatus | null;
  companyId: string;
  allowedModules?: string[];
  createdAt: Date;
  updatedAt: Date;
  company: {
    id: string;
    name: string;
    email: string;
    logo?: string | null;
    approvalStatus: string;
    approvedAt: Date | null;
  };
}

/** Row-level Approve/Reject: sellers self-register with isActive true while sellerStatus is pending. */
export function userRowShowsApproveReject(
  user: Pick<PendingUser, "role" | "isActive" | "sellerStatus" | "company">,
): boolean {
  if (user.role === "SELLER" || user.role === "BUYER_SELLER") {
    return (
      user.sellerStatus == null ||
      user.sellerStatus === SellerStatus.PENDING_APPROVAL
    );
  }
  return !user.isActive && user.company?.approvalStatus !== "rejected";
}

export interface UserStatistics {
  total: number;
  active: number;
  inactive: number;
  pending: number;
  recentRegistrations: number;
  byRole: Record<string, number>;
}

export interface UserFilters {
  search?: string;
  role?: string;
  companyId?: string;
  country?: string;
  isActive?: boolean;
  approvalStatus?: string;
  startDate?: string;
  endDate?: string;
  page?: number;
  limit?: number;
}

